import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section className="bg-white" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight mx-auto"
            style={{ 
              maxWidth: '22ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            What Our Customers Say
          </h2>
          <p 
            className="text-lg sm:text-xl text-gray-600 mx-auto leading-relaxed"
            style={{ 
              maxWidth: '52ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Join thousands of satisfied passengers who got their compensation
          </p>
        </div>

        {/* Rating Summary */}
        <div className="flex items-center justify-center gap-6 mb-12 flex-wrap">
          <div className="flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-gray-900">4.9/5.0</p>
            <p className="text-sm text-gray-600 whitespace-nowrap">Based on 12,450+ reviews</p>
          </div>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300">
              <CardContent className="pt-6">
                {/* Avatar */}
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-blue-200"
                  />
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                    <p className="text-xs text-gray-600">{testimonial.role}</p>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Content */}
                <p 
                  className="text-gray-700 leading-relaxed mb-4 text-sm"
                  style={{ 
                    textWrap: 'balance',
                    WebkitTextWrap: 'balance'
                  }}
                >
                  "{testimonial.content}"
                </p>

                {/* Compensation Badge */}
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                  Received {testimonial.compensation}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
